<template>
  <div class="screen page formActions b-soft">
    <div id="pantalla-espera" v-if="isLoading"></div>
    <div class="grid">
      <form v-on:submit.prevent="actionForm(id, servicio, 'servicios', 'form')" class="form layout">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <label for="color">Selecciona un Color</label>
              <swatches v-model="servicio.color" :colors="colors" row-length="20" popover-to="right" swatch-size="20"></swatches>
            </div>
            <div class="col-12" v-bind:class="{'filled': servicio.nombre != ''}">
              <label for="nombre">Nombre</label>
              <input id="nombre" type="text" v-model="servicio.nombre" placeholder="Escribe algo...">
            </div>
            <div class="col-12" v-bind:class="{'filled': servicio.abreviacion != ''}">
              <label for="abreviacion">Abreviación</label>
              <input id="abreviacion" type="text" v-model="servicio.abreviacion" placeholder="Escribe algo...">
            </div>
            <div class="col-12" v-bind:class="{'filled': servicio.descripcion != ''}">
              <label for="descripcion">Descripción</label>
              <textarea id="descripcion" v-model="servicio.descripcion" placeholder="Escribe algo..."></textarea>
            </div>
            <div class="col-12">
              <ul v-if="messages.length" class="messages-container">
                <li v-for="message in messages" :key="message.content" v-bind:class="['message-item t-12-px', message.type]"><i class="fas fa-times" @click.prevent.stop="delete_message(message)"></i> {{message.content}}</li>
              </ul>
            </div>
            <div class="col-12">
              <button v-if="id" type="submit" class="btn b-secondary">Guardar Cambios</button>
              <button v-if="id" v-on:click.prevent="actionForm(id, servicio, 'servicios', 'clone')" class="btn b-primary">Clonar Elemento</button>
              <button v-else type="submit" class="btn b-secondary">Crear Nuevo Elemento</button>
            </div>
          </div>
        </div>
      </form>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import Swatches from 'vue-swatches'
import router from '@/router'
import { getColors } from '@/colors.js'
import { db, auth } from '@/firebase'
export default {
  name: 'app',
  components: {
    GetFooter,
    Swatches
  },
  data() {
    return {
      isLoading: false,
      isEditing: false, 
      id: this.$route.params.id,
      servicio: [],
      servicios: [],
      usuario_login: [],
      messages: [],
      colors: getColors
    }
  },
  firestore () {
    return {
      servicios: db.collection('servicios'),
      usuario_login: db.collection('usuarios').doc(auth.currentUser.uid)
    }
  },
  created() {
    if(this.$route.params.id){
      db.collection('servicios').doc(this.id)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.id = doc.id
          this.servicio = doc.data()
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
    }
  },
  watch: {
    servicio: {
      deep: true,
      handler(newArray, oldArray){
        if(oldArray.nombre){
          this.isEditing = true
        }else{
          this.isEditing = false
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.isEditing === true){
      const answer = window.confirm('¿Estás Seguro? Se perderá la información que se haya modificado')
      if(answer){
        next()
      } else {
        next(false)
      }
    }else{
      next()
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },
  methods: {
    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
    },
    delete_message (value){
     this.messages.splice(this.messages.indexOf(value), 1)
    },
    actionForm (id, elemento, collection, type) {
      const id_servicio = id
      var item_nombre = elemento.nombre
      var item_abreviacion = elemento.abreviacion
      var item_color = elemento.color
      var item_creacion = new Date()
      var url = 'dashboard'

      var nuevo_orden = this.servicios.length + 1

      this.messages = []

      if(!item_nombre) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar un nombre'
        }
        this.messages.push(the_message)
      }

      if(!item_abreviacion) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar una abreviación'
        }
        this.messages.push(the_message)
      }

      if(!item_color) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario seleccionar un color'
        }
        this.messages.push(the_message)
      }

      if(!elemento.abreviacion){
        elemento.abreviacion = '';
      }

      if(!elemento.descripcion){
        elemento.descripcion = '';
      }

      if(!this.messages.length) {
        this.isLoading = true
        this.isEditing = false
        var vm = this
        //Verificar tipo de accion
        if(type === 'clone'){
          //Clonar elemento
          if(window.confirm('¿Estás Seguro? Si no haz guardado los cambios estos se aplicarán solamente al elemento clonado.')){
            db.collection(collection).add({
              color: elemento.color,
              fecha_creacion: item_creacion,
              fecha_modificacion: item_creacion,
              nombre: elemento.nombre, 
              abreviacion: elemento.abreviacion, 
              descripcion: elemento.descripcion,
              usuario_creador: vm.usuario_login.nombre, 
              usuario_editor: vm.usuario_login.nombre,
              orden: nuevo_orden
            })
            .then(function(doc) {
              //Documento creado con exito
              vm.isLoading = false
              router.push('/servicios/', () => {})
            })
            .catch(function(error) {
              //Error al crear
              vm.isLoading = false
              vm.messages.push({type: 'fatal b-fail', content: error.message})
            })
          }
        }else if(id_servicio && type === 'form'){
          //Actualizar elemento
          db.collection(collection).doc(id_servicio).update({
            color: elemento.color,
            fecha_modificacion: item_creacion,
            nombre: elemento.nombre, 
            abreviacion: elemento.abreviacion, 
            descripcion: elemento.descripcion,
            usuario_editor: vm.usuario_login.nombre,
            orden: elemento.orden
          })
          .then(function(doc) {
            //Se actualizo con exito el documento
            setTimeout(function(){
              vm.isLoading = false
            }, 1200)
            vm.messages.push({type: 'success b-secondary', content: 'Se han guardado los cambios'})
          })
          .catch(function(error) {
            //Error al actualizar
            vm.isLoading = false
            vm.messages.push({type: 'fatal b-fail', content: error.message})
          })
        }else if(!id_servicio && type === 'form'){
          //Crear elemento
          db.collection(collection).add({
            color: elemento.color,
            fecha_creacion: item_creacion,
            fecha_modificacion: item_creacion,
            nombre: elemento.nombre, 
            abreviacion: elemento.abreviacion, 
            descripcion: elemento.descripcion,
            usuario_creador: vm.usuario_login.nombre, 
            usuario_editor: vm.usuario_login.nombre,
            orden: nuevo_orden
          })
          .then(function(doc) {
            //Documento creado con exito
            vm.isLoading = false
            router.push('/servicios/', () => {})
          })
          .catch(function(error) {
            //Error al crear
            vm.isLoading = false
            vm.messages.push({type: 'fatal b-fail', content: error.message})
          })
        }
      }
    }
  },
}
</script>
<style src='vue-swatches/dist/vue-swatches.min.css'></style>